/*
Author : Claudine Manrique


Markup :

<a class="js-edit-prov" data-prov="TP-LBBPBA" href="/mon-compte/abonnement?prov=" target="_blank" class="button">s'abonner</a>

Setup :

$(function() {
    $("body").editProvWebMobile();
});
*/
;(function ($, window, document, undefined) {
    "use strict";

    var pluginName = "editProvWebMobile",
        defaults = {
            target: '.js-edit-prov'
        };

    var isMobileDevice;

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
            this.setEvents();
            this.setMobile();
        },
        setElements: function() {
            this.$element = $(this.element);
            this.$triggers = this.$element.find(this.settings.target);
        },
        setEvents: function() {
            this.$triggers.on("click", $.proxy(this.clickOnTarget, this));
        },
        setMobile: function () {
            isMobileDevice = isMobile();
        },
        clickOnTarget: function(e) {
            var element = e.currentTarget;
            if (element.getAttribute("data-prov")) {
                var href = element.getAttribute("href");
                var newHref = href + "?prov=" + (isMobileDevice ? 'M-' : 'W-') + element.getAttribute("data-prov");
                element.setAttribute("href", newHref);
            }
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);
